<template>
  <section class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <h3>资金记录
</h3>
      <span>每个场馆的数据将有一定时间的延迟，仅供参考使用</span>
    </div>
    <div class="myCenterCommon__users_layout__params__2DfEC">
      <div class="myCenterCommon__check_wrap__3bM7H">
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fl__waaJH" style="width: 35%">
          <div class="myCenterCommon__users_params__label__3y-Q5">选择游戏：</div>
          <div>
            <el-select v-model="api_type" placeholder="请选择平台" @change="changApiType">
              <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
       <div class="myCenterCommon__check_wrap__3bM7H">


        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fr__3TeIF">
          <div class="myCenterCommon__users_params__label__3y-Q5">交易类型：</div>
          <el-radio-group v-model="type"  @change="changeDate">
            <el-radio-button :label="1">存款</el-radio-button>
            <el-radio-button :label="2">取款</el-radio-button>
            <el-radio-button :label="3">转入</el-radio-button>
            <el-radio-button :label="4">转出</el-radio-button>
          </el-radio-group>
        </div>
      </div>
       <div class="myCenterCommon__check_wrap__3bM7H">
      
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fr__3TeIF">
          <div class="myCenterCommon__users_params__label__3y-Q5">时间选择：</div>
          <el-radio-group v-model="date" @change="changeDate">
            <el-radio-button :label="1">今日</el-radio-button>
            <el-radio-button :label="2">一周内</el-radio-button>
            <el-radio-button :label="3">半月内</el-radio-button>
            <el-radio-button :label="4">一月内</el-radio-button>
          </el-radio-group>
        </div>
       
      </div>
    </div>
    <el-table :data="transrecordList" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="created_at" label="时间" width="180"> </el-table-column>
      <el-table-column prop="out_trade_no" label="订单号" v-if="type == 1 || type == 2" width="200"> </el-table-column>
      <el-table-column prop="pay_way" label="交易类型"> </el-table-column>
      <el-table-column prop="amount" label="金额"> </el-table-column>
      <el-table-column prop="state" label="状态" width="80">
        <template slot-scope="scope"  > {{ type == 1 || type == 2? stateType12[scope.row.state] :stateType34[scope.row.state] }} </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="transrecordListShowData.total" style="margin: 20px 0 0px 120px" @current-change="getTransrecord" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="transrecordListShowData.total"></el-pagination>
  </section>
</template>
<script>
export default {
  name: 'transRecord',
  data() {
    return {
      date: 4,
      transrecordList: [],
      transrecordListShowData: {},
      type: 1,
      page: 1,
      stateType12: ['未定义', '待审核', '审核通过', '审核拒绝'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
      dogameLis: [],
      api_type: '',
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getTransrecord();
  },
  methods: {
    changApiType() {
      let that = this;
      that.page = 1;
      that.getTransrecord();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: '全平台', platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getTransrecord();
    },

    // 获取交易记录
    getTransrecord() {
      let that = this;
      that.$parent.showLoading();

      let info = {
        date: that.date,
        type: that.type,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.transrecordList = res.data.data;
            that.transrecordListShowData = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/transRecord.vue